"use client";

import { createContext, useContext } from "react";
import type { MeshPhongMaterial } from "three";

export interface MaterialProps {
	variant: "vertical" | "horizontal" | "door" | "double-door" | "shelf" | "background";
	width: number;
	height: number;
	depth: number;
	hover?: boolean;
}

type MaterialContextType = {
	defaultMaterial: MeshPhongMaterial[];
	getMaterial: (props: MaterialProps) => MeshPhongMaterial | MeshPhongMaterial[];
};

export const MaterialContext = createContext<MaterialContextType | null>(null);

export function useMaterialContext() {
	const context = useContext(MaterialContext);

	if (context === null) {
		throw new Error("Material context is not available");
	}

	return context;
}
